import { authClient, API } from "../index";

export const getPlanLogs = (params) => {
	const search = new URLSearchParams();
	if (params?.email) search.set("email", String(params.email).trim());
	if (params?.limit) search.set("limit", String(params.limit));
	const q = search.toString();
	return authClient().get(`${API}/plan-log${q ? `?${q}` : ""}`);
};

/** Estadísticas de ingresos y usuarios (solo admin). */
export const getPlanLogStats = () => {
	return authClient().get(`${API}/plan-log/stats`);
};

/** Serie temporal de ingresos para gráfico del dashboard (solo admin). */
export const getPlanLogRevenueChart = (granularity = "day") => {
	const g = String(granularity || "day").trim().toLowerCase();
	return authClient().get(`${API}/plan-log/revenue-chart?granularity=${encodeURIComponent(g)}`);
};
